import { useState, useEffect } from "react";
import JWPlayer from '@jwplayer/jwplayer-react';

// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { formatTime } from '../helpers/formatTime'

const FrontPage = ({ setActiveCategory,
    setCategories,
    setCategoryList,
    categoryList,
    setActiveVideo,
    activeVideo
}) => {

    const [activeSwiper, setActiveSwiper] = useState({});

    const [highlightedVideoList, setHighlightedVideoList] = useState([]);
    const [rerender, setRerender] = useState(true);

    const [sliderDescription, setSliderDescription] = useState([]);

    useEffect(() => {
        var highlighted = [];
        categoryList.forEach(cat => {
            highlighted.push({...cat.videos[0], categoryId: cat.id });
        });
        
        const unique = Array.from(new Set(highlighted.map(a => a.id)))
            .map(id => {
            return highlighted.find(a => a.id === id)
        })
        setHighlightedVideoList(unique);

        var playerList = [];
        highlighted.forEach((highlight) => {
            playerList.push({ 'playerId': highlight.id, 'playerStarted': false });
        })

        setSliderDescription(playerList);

    }, [categoryList]);

    useEffect(() => {
        setRerender(true)
    }, [activeVideo.id])

    useEffect(() => {
        if (rerender) {
            setRerender(false)
        }
    }, [rerender]);

    return (
        <>
                {!rerender && (
                    <div className="container d-video-container">
                        <div className="row">
                            <div className="col">
                                <div className="swiper d-header-main-video">

                                    <Swiper
                                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                                        slidesPerView={1}
                                        onSlideChange={(slide) => {

                                            var jwplayer_elements = activeSwiper.slides[slide.previousIndex].getElementsByClassName('jwplayer');

                                            var currentHighlight = [...sliderDescription];

                                            if (jwplayer_elements.length > 0) {
                                                for (var i = 0; i < jwplayer_elements.length; i++) {
                                                    window.jwplayer(jwplayer_elements[i].id).stop();
                                                    currentHighlight.find(e => (e.playerId === jwplayer_elements[i].id)).playerStarted = false;
                                                }
                                            }

                                            setSliderDescription([...currentHighlight]);
                                        }
                                        }
                                        onSwiper={(swiper) => {
                                            setActiveSwiper({ ...swiper });
                                        }}
                                        navigation
                                    >
                                        {highlightedVideoList && highlightedVideoList.map((video) => (
                                            <SwiperSlide key={video.id}>
                                                <div id="videoInfo" className="d-hide-element">
                                                    <p>Playlist id: {video.categoryId}</p>
                                                    <p>Media id: {video.id}</p>
                                                </div>
                                                <div className="swiper-wrapper">
                                                    <div className="swiper-slide bg-primary">

                                                        {!((sliderDescription.find(e => e.playerId === video.id)).playerStarted) ?
                                                            <div className="d-main-video-data">
                                                                <label className="d-main-video-duration">{formatTime(video.duration)}</label>
                                                                <h2 className="d-main-video-title">{video.title}</h2>
                                                                <div className="d-main-video-description">{video.description}</div>
                                                            </div>
                                                            : <div></div>
                                                        }

                                                        <JWPlayer
                                                            file={video.url} 
                                                            library='https://cdn.jwplayer.com/libraries/uSnweboJ.js'
                                                            onPlay={() => {
                                                                var currentHighlight = [...sliderDescription];
                                                                currentHighlight.find(e => (e.playerId === video.id)).playerStarted = true;

                                                                setSliderDescription([...currentHighlight]);
                                                            }}
                                                            id={video.id}
                                                            image={video.thumbnail} 
                                                        />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))}

                                    </Swiper>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </>
    );
};

export default FrontPage;